var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostLux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15606_291621)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 76C58.9864 76 76 58.9864 76 38C76 17.0136 58.9864 0 38 0C17.0136 0 0 17.0136 0 38C0 58.9864 17.0136 76 38 76Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2718 43.5948C63.2768 39.9288 62.291 36.3295 60.4188 33.1776C61.2481 27.2489 59.6923 21.8246 55.6539 18.6728C54.0767 17.4499 52.2228 16.6339 50.2557 16.2967C47.0197 12.9095 42.9858 10.9484 38.6396 11.0102C35.6305 11.0941 32.7209 12.1062 30.3094 13.9079C26.7267 13.8636 23.2193 14.9372 20.2752 16.9792C10.7536 23.7149 10.1657 39.3157 18.9861 51.7961C27.8081 64.2773 42.1341 68.1153 52.4977 62.3519C54.2742 61.364 55.8089 59.9935 56.9906 58.3396C58.9724 56.4282 60.5498 54.1379 61.6288 51.6048C62.7078 49.0717 63.2666 46.3482 63.2718 43.5948Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.5477 27.4442C62.3771 39.9566 62.8815 56.5961 52.5224 62.3595C42.1626 68.1228 27.815 64.3168 18.9885 51.7954C10.1629 39.2741 10.7552 23.7127 20.2768 16.9696C29.7977 10.2249 44.7034 14.9317 53.5477 27.4442Z",
    fill: "url(#paint0_linear_15606_291621)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7968 36.021C58.0464 50.0214 49.8802 61.5227 39.5568 61.7097C29.2327 61.8967 20.6567 50.6949 20.3892 36.6945C20.1217 22.6934 28.3193 11.1928 38.6426 11.0103C48.9659 10.8277 57.5606 22.0198 57.7968 36.021Z",
    fill: "url(#paint1_linear_15606_291621)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4061 46.7862C46.6057 56.7615 34.5344 60.3499 27.4336 54.8094C20.3335 49.2688 20.8909 36.6759 28.6824 26.7006C36.4739 16.7244 48.5541 13.1323 55.6549 18.6773C62.7557 24.2224 62.1984 36.8101 54.4069 46.7862H54.4061Z",
    fill: "url(#paint2_linear_15606_291621)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.274 43.5943C63.2742 47.6391 62.0749 51.5931 59.8279 54.9564C57.581 58.3196 54.3872 60.941 50.6504 62.4892C46.9136 64.0373 42.8016 64.4426 38.8345 63.6539C34.8674 62.8652 31.2232 60.9178 28.3628 58.058C25.5024 55.1982 23.5542 51.5545 22.7646 47.5875C21.975 43.6205 22.3794 39.5085 23.9267 35.7714C25.4741 32.0343 28.0948 28.8399 31.4576 26.5922C34.8203 24.3445 38.774 23.1444 42.8188 23.1436C45.5065 23.1371 48.1689 23.6616 50.6533 24.687C53.1377 25.7124 55.395 27.2185 57.2957 29.1188C59.1964 31.019 60.7029 33.276 61.7289 35.7602C62.7548 38.2443 63.2799 40.9067 63.274 43.5943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 37.0187C29.2674 36.9874 29.5885 36.9517 30.0162 36.9032C30.5557 36.8451 31.0966 36.8205 31.639 36.8272C32.1278 36.8272 32.6151 36.872 33.0965 36.9614C33.571 37.0447 34.025 37.2185 34.4339 37.4732C34.8422 37.7325 35.1745 38.0954 35.3966 38.5253C35.6633 39.0804 35.7892 39.6929 35.7617 40.3083C35.7801 40.8567 35.6799 41.4026 35.4681 41.9088C35.2974 42.3065 35.0328 42.6567 34.6969 42.9296C34.3706 43.1829 33.9958 43.3677 33.5957 43.4735C33.1807 43.5805 32.7538 43.6343 32.3253 43.6337H31.7992C31.675 43.6266 31.5515 43.6101 31.4297 43.5845V46.7497C31.1912 46.7944 30.9781 46.825 30.7874 46.8429C30.6011 46.8429 30.4223 46.8697 30.2614 46.8697C29.8649 46.8644 29.4698 46.8242 29.0804 46.7497L29.0625 37.0187ZM31.4118 41.6056C31.4843 41.6333 31.5614 41.6469 31.639 41.6458C31.753 41.6525 31.8678 41.6525 31.9818 41.6458C32.1631 41.6595 32.3451 41.6329 32.5149 41.5679C32.6847 41.5029 32.8379 41.4011 32.9636 41.2698C33.0894 41.1385 33.1845 40.981 33.2421 40.8085C33.2997 40.6361 33.3184 40.4531 33.2969 40.2726C33.3038 40.0388 33.2659 39.8059 33.1851 39.5863C33.1138 39.4153 33.0042 39.2628 32.8647 39.1408C32.7255 39.0273 32.5625 38.9466 32.3879 38.9046C32.1997 38.8698 32.0081 38.8578 31.8171 38.8688H31.6301C31.5574 38.8644 31.4845 38.8644 31.4118 38.8688V41.6056Z",
    fill: "url(#paint3_linear_15606_291621)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2034 43.2775C36.1976 42.7634 36.2743 42.2518 36.4307 41.762C36.5661 41.3285 36.7924 40.929 37.0946 40.59C37.3963 40.2584 37.7696 40.0006 38.1869 39.8367C38.6668 39.6499 39.1786 39.5588 39.6935 39.5684C40.2142 39.558 40.732 39.6491 41.2179 39.8367C41.6352 40.0006 42.0085 40.2584 42.3103 40.5892C42.612 40.929 42.8393 41.3284 42.9741 41.762C43.1292 42.252 43.2047 42.7637 43.1977 43.2775C43.2047 43.7826 43.1292 44.2855 42.9741 44.7662C42.8385 45.1945 42.6121 45.5884 42.3103 45.9211C42.0068 46.2471 41.6333 46.5001 41.2179 46.661C40.7308 46.843 40.2134 46.9307 39.6935 46.9196C39.1794 46.93 38.6681 46.8422 38.1869 46.661C37.7715 46.5001 37.3981 46.2472 37.0946 45.9211C36.7928 45.5884 36.5663 45.1945 36.4307 44.7662C36.2743 44.2857 36.1975 43.7828 36.2034 43.2775ZM40.8789 43.2775C40.9084 42.8129 40.8064 42.3494 40.5846 41.9401C40.4891 41.7933 40.3562 41.6746 40.1995 41.5963C40.0429 41.518 39.8682 41.4829 39.6935 41.4945C39.5185 41.4818 39.3434 41.5165 39.1864 41.5949C39.0295 41.6733 38.8965 41.7926 38.8016 41.9401C38.6135 42.3561 38.5162 42.8075 38.5162 43.2641C38.5162 43.7207 38.6135 44.1721 38.8016 44.5882C38.8962 44.736 39.0291 44.8555 39.1861 44.9339C39.3431 45.0124 39.5184 45.0469 39.6935 45.0337C39.8683 45.0459 40.0431 45.0109 40.1999 44.9326C40.3566 44.8542 40.4894 44.7353 40.5846 44.5882C40.8022 44.187 40.9041 43.7332 40.8789 43.2775Z",
    fill: "url(#paint4_linear_15606_291621)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7531 42.3552C48.0065 42.42 48.2546 42.5087 48.493 42.6182C48.7054 42.7173 48.8984 42.8529 49.0638 43.0191C49.2284 43.1904 49.3559 43.3938 49.4378 43.6166C49.5369 43.8908 49.5839 44.1807 49.5764 44.4727C49.5779 44.8066 49.5049 45.1374 49.3618 45.4399C49.2194 45.7436 49.0054 46.0083 48.7382 46.2111C48.434 46.4444 48.0895 46.6196 47.7218 46.7282C47.2693 46.8634 46.7986 46.9279 46.3263 46.9196C45.922 46.9218 45.5183 46.8904 45.1192 46.8258C44.7163 46.7513 44.3208 46.6411 43.9375 46.4964C43.9918 45.8472 44.1625 45.2129 44.4412 44.624C45.0242 44.8913 45.6581 45.0295 46.2995 45.0293H46.6385C46.7458 45.0234 46.8523 45.004 46.9551 44.9712C47.0371 44.9422 47.1116 44.8982 47.1779 44.8423C47.2063 44.8137 47.2284 44.7795 47.2431 44.742C47.2577 44.7044 47.2644 44.6643 47.2629 44.624C47.2639 44.5671 47.2478 44.5112 47.2167 44.4635C47.1857 44.4158 47.141 44.3786 47.0885 44.3565C46.9582 44.2926 46.8226 44.2403 46.6832 44.2L45.7608 43.9422C45.306 43.8237 44.8917 43.5848 44.5611 43.2508C44.3975 43.0706 44.2715 42.8595 44.1904 42.63C44.1093 42.4005 44.0747 42.1571 44.0888 41.9141C44.0843 41.5803 44.158 41.2509 44.3026 40.9507C44.4516 40.6601 44.664 40.4067 44.9225 40.2063C45.2034 40.0025 45.519 39.8516 45.8539 39.7607C46.2407 39.6483 46.6418 39.5929 47.0446 39.5961C47.4229 39.5991 47.8003 39.6365 48.1719 39.7078C48.5817 39.7786 48.9863 39.8829 49.3797 40.0193C49.3573 40.3352 49.2985 40.6482 49.2061 40.9507C49.1167 41.2569 49.0019 41.5557 48.8633 41.8426C48.5733 41.7295 48.2752 41.6386 47.9715 41.5706C47.6607 41.4943 47.3422 41.4538 47.0222 41.4499C46.5759 41.4499 46.3844 41.5661 46.3844 41.8023C46.384 41.851 46.3977 41.8987 46.4237 41.9398C46.4497 41.9809 46.4871 42.0136 46.5312 42.034C46.6392 42.0907 46.7525 42.1354 46.8702 42.1682L47.7531 42.3552Z",
    fill: "url(#paint5_linear_15606_291621)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2091 41.6466H50.1988C50.1554 41.4799 50.1255 41.3099 50.1094 41.1384V40.6921V40.2465C50.1265 40.0781 50.1563 39.9112 50.1988 39.7473H56.5105C56.553 39.9112 56.5828 40.0781 56.5999 40.2465C56.5999 40.403 56.6223 40.5543 56.6223 40.6928C56.6223 40.8307 56.6223 40.9909 56.5999 41.1384C56.5835 41.3098 56.5537 41.4797 56.5105 41.6466H54.5047V46.7415C54.2685 46.7766 54.0591 46.8034 53.8632 46.8257C53.6915 46.8448 53.5188 46.8537 53.3461 46.8526C53.1896 46.8526 53.0249 46.8526 52.8335 46.8257C52.6412 46.7989 52.4363 46.7766 52.2091 46.7415V41.6466Z",
    fill: "url(#paint6_linear_15606_291621)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0703 48.9514H29.5159V50.9572H30.5411V51.3499H29.0703V48.9514Z",
    fill: "url(#paint7_linear_15606_291621)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1445 48.9531H31.5901V50.459C31.5854 50.5275 31.5959 50.5962 31.6209 50.6602C31.6459 50.7241 31.6846 50.7818 31.7345 50.8291C31.7843 50.8763 31.8439 50.912 31.9091 50.9336C31.9743 50.9551 32.0435 50.962 32.1117 50.9537C32.1792 50.9596 32.2471 50.951 32.311 50.9286C32.3749 50.9061 32.4333 50.8702 32.4822 50.8234C32.5312 50.7766 32.5696 50.7199 32.5948 50.657C32.6201 50.5942 32.6317 50.5266 32.6288 50.459V48.939H33.0743V50.459C33.0591 50.7023 32.9518 50.9307 32.7741 51.0976C32.5964 51.2645 32.3618 51.3574 32.118 51.3574C31.8742 51.3574 31.6396 51.2645 31.4619 51.0976C31.2842 50.9307 31.1769 50.7023 31.1617 50.459L31.1445 48.9531Z",
    fill: "url(#paint8_linear_15606_291621)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4503 50.1242L33.7409 48.9514H34.2357L34.5568 49.5356C34.6328 49.6734 34.7088 49.8254 34.7088 49.8254C34.7505 49.7263 34.7982 49.6295 34.8511 49.5348L35.1812 48.9514H35.6759L34.9584 50.1242L35.7162 51.3499H35.2259L34.8601 50.7076C34.7796 50.5735 34.7133 50.4267 34.7133 50.4267C34.7133 50.4267 34.6462 50.5742 34.5657 50.7076L34.1962 51.3499H33.7148L34.4503 50.1242Z",
    fill: "url(#paint9_linear_15606_291621)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4023 48.9514H37.8247V49.3262H36.8352V49.9454H37.6325V50.3157H36.8352V50.9572H37.8784V51.3499H36.4031L36.4023 48.9514Z",
    fill: "url(#paint10_linear_15606_291621)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7793 48.9514H39.2249L39.6704 50.1287C39.7241 50.2665 39.7867 50.4759 39.7867 50.4759C39.7867 50.4759 39.8493 50.2673 39.9022 50.1287L40.3485 48.9514H40.794L41.066 51.3499H40.6197L40.5176 50.0124V49.6473C40.5176 49.6473 40.4461 49.8746 40.3924 50.0124L40.0139 50.9043H39.6384L39.2554 50.0124C39.1973 49.8746 39.1258 49.6429 39.1258 49.6429V50.0124L39.0237 51.3499H38.5781L38.7793 48.9514Z",
    fill: "url(#paint11_linear_15606_291621)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9219 48.9514H42.7735C43.2191 48.9514 43.5045 49.1749 43.5045 49.5669C43.5076 49.6689 43.4826 49.7698 43.4323 49.8587C43.382 49.9475 43.3082 50.0208 43.2191 50.0706C43.3357 50.1078 43.4367 50.1828 43.5062 50.2837C43.5756 50.3845 43.6096 50.5056 43.6028 50.6279C43.6028 51.1047 43.2191 51.3186 42.7825 51.3186H41.9219V48.9514ZM42.7735 49.923C42.8134 49.9251 42.8533 49.9186 42.8905 49.904C42.9276 49.8894 42.9613 49.867 42.9891 49.8384C43.017 49.8097 43.0384 49.7755 43.052 49.7379C43.0656 49.7004 43.071 49.6603 43.0678 49.6205C43.0706 49.5804 43.0646 49.5401 43.0503 49.5025C43.0359 49.4649 43.0135 49.4309 42.9846 49.4029C42.9557 49.3749 42.9211 49.3535 42.8831 49.3402C42.8451 49.327 42.8046 49.3222 42.7646 49.3262H42.3548V49.923H42.7735ZM42.8182 50.9572C42.9092 50.9572 42.9965 50.9211 43.0608 50.8567C43.1252 50.7924 43.1613 50.7051 43.1613 50.6141C43.1613 50.5231 43.1252 50.4358 43.0608 50.3715C42.9965 50.3071 42.9092 50.271 42.8182 50.271H42.3727V50.9572H42.8182Z",
    fill: "url(#paint12_linear_15606_291621)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.464 48.9119C45.6248 48.9088 45.7845 48.938 45.9338 48.9977C46.0831 49.0574 46.2188 49.1464 46.3331 49.2595C46.4474 49.3726 46.5378 49.5075 46.5991 49.6561C46.6603 49.8047 46.6912 49.9642 46.6897 50.1249C46.6897 50.45 46.5606 50.7618 46.3307 50.9916C46.1009 51.2215 45.7891 51.3506 45.464 51.3506C45.139 51.3506 44.8272 51.2215 44.5974 50.9916C44.3675 50.7618 44.2384 50.45 44.2384 50.1249C44.2365 49.9641 44.2671 49.8044 44.3282 49.6556C44.3893 49.5068 44.4797 49.3718 44.5941 49.2586C44.7084 49.1454 44.8444 49.0564 44.9938 48.9968C45.1433 48.9373 45.3032 48.9084 45.464 48.9119ZM45.464 50.9714C45.5713 50.9685 45.677 50.9442 45.7747 50.8998C45.8724 50.8555 45.9603 50.7919 46.033 50.713C46.1057 50.6341 46.1619 50.5414 46.1982 50.4404C46.2344 50.3394 46.2501 50.2321 46.2442 50.1249C46.2536 50.0165 46.2405 49.9072 46.2054 49.8041C46.1704 49.701 46.1144 49.6063 46.0408 49.526C45.9672 49.4457 45.8778 49.3816 45.7781 49.3377C45.6784 49.2939 45.5707 49.2712 45.4618 49.2712C45.3529 49.2712 45.2452 49.2939 45.1455 49.3377C45.0459 49.3816 44.9564 49.4457 44.8828 49.526C44.8093 49.6063 44.7532 49.701 44.7182 49.8041C44.6832 49.9072 44.67 50.0165 44.6795 50.1249C44.6734 50.2325 44.6891 50.3402 44.7256 50.4415C44.7622 50.5429 44.8187 50.6358 44.8919 50.7148C44.9652 50.7938 45.0536 50.8572 45.1519 50.9013C45.2502 50.9454 45.3563 50.9692 45.464 50.9714Z",
    fill: "url(#paint13_linear_15606_291621)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4258 48.9531H47.8713V50.459C47.8669 50.5274 47.8776 50.596 47.9027 50.6598C47.9277 50.7237 47.9665 50.7813 48.0163 50.8285C48.066 50.8757 48.1256 50.9114 48.1907 50.933C48.2557 50.9546 48.3248 50.9617 48.3929 50.9537C48.4604 50.9595 48.5283 50.9508 48.5921 50.9283C48.656 50.9058 48.7143 50.8699 48.7632 50.8231C48.8121 50.7763 48.8505 50.7197 48.8758 50.6569C48.9011 50.5941 48.9128 50.5266 48.91 50.459V48.939H49.3556V50.459C49.339 50.7012 49.2311 50.9281 49.0536 51.0938C48.8762 51.2596 48.6424 51.3518 48.3996 51.3518C48.1568 51.3518 47.9231 51.2596 47.7456 51.0938C47.5682 50.9281 47.4602 50.7012 47.4437 50.459L47.4258 48.9531Z",
    fill: "url(#paint14_linear_15606_291621)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2422 48.9529H51.0096C51.1706 48.9402 51.3338 48.9626 51.4865 49.0192C51.6048 49.0812 51.704 49.1743 51.7731 49.2886C51.8423 49.4029 51.8788 49.5339 51.8788 49.6675C51.8788 49.801 51.8423 49.932 51.7731 50.0463C51.704 50.1606 51.6048 50.2537 51.4865 50.3157C51.5185 50.3507 51.5461 50.3902 51.5662 50.4319L52.0565 51.3238H51.5752L51.1028 50.4319H50.6885V51.3238H50.2422V48.9529ZM51.0625 50.0668C51.1129 50.0716 51.1637 50.0651 51.2113 50.0479C51.2589 50.0308 51.3021 50.0033 51.3378 49.9675C51.3735 49.9317 51.4009 49.8884 51.418 49.8408C51.4351 49.7932 51.4414 49.7424 51.4366 49.692C51.4366 49.4648 51.339 49.3269 50.991 49.3269H50.6654V50.0668H51.0625Z",
    fill: "url(#paint15_linear_15606_291621)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8177 48.912C54.1433 48.8956 54.4615 49.0044 54.7096 49.2153L54.4957 49.5357C54.3176 49.3915 54.0961 49.3114 53.8669 49.3084C53.7581 49.3019 53.6491 49.3185 53.5472 49.3572C53.4453 49.3959 53.3528 49.4558 53.2757 49.5329C53.1987 49.61 53.1389 49.7026 53.1003 49.8046C53.0616 49.9065 53.0451 50.0155 53.0517 50.1243C53.0438 50.233 53.0585 50.3421 53.0948 50.4448C53.1311 50.5475 53.1883 50.6416 53.2628 50.7211C53.3373 50.8006 53.4274 50.8638 53.5275 50.9068C53.6276 50.9498 53.7356 50.9715 53.8445 50.9707C54.068 50.967 54.2804 50.8791 54.4421 50.7256V50.4588H54.077V50.0885H54.8295V51.35H54.4376V51.2337V51.1361C54.2492 51.3044 54.0039 51.3949 53.7514 51.3895C53.593 51.3891 53.4365 51.3565 53.2911 51.2937C53.1457 51.231 53.0147 51.1393 52.9058 51.0243C52.797 50.9094 52.7126 50.7735 52.6579 50.6249C52.6032 50.4763 52.5793 50.3182 52.5875 50.1601C52.5801 49.9957 52.6066 49.8316 52.6656 49.678C52.7245 49.5243 52.8146 49.3846 52.9301 49.2674C53.0456 49.1502 53.184 49.0582 53.3368 48.997C53.4895 48.9359 53.6532 48.9069 53.8177 48.912Z",
    fill: "url(#paint16_linear_15606_291621)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15606_291621",
    x1: 47.1465,
    y1: 51.2381,
    x2: 23.214,
    y2: 25.7014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FABE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FBCB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15606_291621",
    x1: 48.5069,
    y1: 14.8475,
    x2: 37.063,
    y2: 42.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15606_291621",
    x1: 5693.7,
    y1: 3383.07,
    x2: 3086.99,
    y2: 3553.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15606_291621",
    x1: 27.427,
    y1: 41.8283,
    x2: 59.3157,
    y2: 41.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15606_291621",
    x1: 479.659,
    y1: 773.464,
    x2: 980.05,
    y2: 773.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15606_291621",
    x1: 401.486,
    y1: 770.722,
    x2: 804.944,
    y2: 770.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15606_291621",
    x1: 462.994,
    y1: 749.703,
    x2: 928.89,
    y2: 749.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15606_291621",
    x1: 122.33,
    y1: 325.431,
    x2: 227.563,
    y2: 325.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15606_291621",
    x1: 153.512,
    y1: 327.234,
    x2: 291.609,
    y2: 327.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15606_291621",
    x1: 160.604,
    y1: 325.431,
    x2: 303.784,
    y2: 325.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15606_291621",
    x1: 129.944,
    y1: 325.431,
    x2: 235.496,
    y2: 325.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15606_291621",
    x1: 196.271,
    y1: 325.431,
    x2: 374.211,
    y2: 325.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15606_291621",
    x1: 148.518,
    y1: 321.834,
    x2: 268.8,
    y2: 321.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15606_291621",
    x1: 199.677,
    y1: 330.052,
    x2: 375.073,
    y2: 330.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15606_291621",
    x1: 169.812,
    y1: 327.235,
    x2: 307.872,
    y2: 327.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15606_291621",
    x1: 165.28,
    y1: 322.721,
    x2: 295.049,
    y2: 322.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15606_291621",
    x1: 194.819,
    y1: 334.843,
    x2: 355.361,
    y2: 334.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA12E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008736"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15606_291621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLux);
export default __webpack_public_path__ + "static/media/POSTLux.324d8feee0b81f6ad614b2f7980d4430.svg";
export { ForwardRef as ReactComponent };